import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function Benefits() {
  const { ref: sectionRef, isVisible } = useScrollReveal();

  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Lower Energy Bills',
      description: 'Reduce heating and cooling costs by 30-50% with superior thermal insulation',
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Moisture Protection',
      description: 'Prevent mold, mildew, and water damage with our moisture-resistant foam',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-volume-mute-line',
      title: 'Sound Dampening',
      description: 'Enjoy a quieter home with excellent noise reduction properties',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly',
      description: 'Reduce your carbon footprint with energy-efficient insulation solutions',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Increased Comfort',
      description: 'Maintain consistent temperatures throughout your property year-round',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Higher Property Value',
      description: 'Boost your property value with professional insulation upgrades',
      color: 'from-indigo-500 to-indigo-600'
    }
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Benefits of Spray Foam Insulation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover why spray foam is the superior choice for Arizona properties
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`group bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent hover:-translate-y-3 cursor-default scroll-reveal ${isVisible ? 'revealed' : ''}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-125 group-hover:rotate-12 transition-all duration-500 shadow-lg`}>
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors duration-300">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className={`group bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent cursor-default scroll-reveal ${isVisible ? 'revealed' : ''}`}
                style={{ width: '280px', transitionDelay: `${index * 100}ms` }}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-125 group-hover:rotate-12 transition-all duration-500 shadow-lg`}>
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
          <div className="text-center mt-4 text-sm text-gray-500">
            <i className="ri-arrow-left-right-line mr-1"></i>
            Swipe to see more
          </div>
        </div>
      </div>
    </section>
  );
}